module.exports = __webpack_public_path__ + "img/Referrer.4da5f398.svg";